import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FeatureGate } from "@/components/FeatureGate";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Store, Trash2, TrendingUp, ShoppingBag } from "lucide-react";
import { brl } from "@/lib/format";
import { toast } from "sonner";

export default function Stores() {
  return <FeatureGate feature="multi_stores" title="Múltiplas unidades disponível no plano Master"><Inner /></FeatureGate>;
}

function Inner() {
  const [list, setList] = useState([]);
  const [consolidated, setConsolidated] = useState([]);
  const [dlg, setDlg] = useState(false);
  const [f, setF] = useState({ name: "", address: "", phone: "", active: true });

  const load = async () => {
    const [s, c] = await Promise.all([
      api.get("/stores"),
      api.get("/stores/consolidated").catch(() => ({ data: [] })),
    ]);
    setList(s.data); setConsolidated(c.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/stores", f); toast.success("Unidade criada"); setDlg(false); setF({ name: "", address: "", phone: "", active: true }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  const del = async (id) => { await api.delete(`/stores/${id}`); toast.success("Removida"); load(); };

  return (
    <div className="space-y-6" data-testid="stores-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="font-display text-3xl font-extrabold text-stone-900">Unidades</h1>
          <p className="text-stone-500">Gerencie múltiplas lojas com visão consolidada.</p></div>
        <Dialog open={dlg} onOpenChange={setDlg}>
          <DialogTrigger asChild><Button className="gap-2 bg-orange-600 hover:bg-orange-700" data-testid="new-store-btn"><Plus className="h-4 w-4" /> Nova unidade</Button></DialogTrigger>
          <DialogContent><DialogHeader><DialogTitle>Nova unidade</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nome</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="store-name" /></div>
              <div><Label>Endereço</Label><Input value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
              <div><Label>Telefone</Label><Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
            </div>
            <DialogFooter><Button onClick={save} className="bg-orange-600 hover:bg-orange-700" data-testid="store-save">Salvar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {consolidated.map((row) => (
          <Card key={row.store.id || "unassigned"} className="rounded-2xl border-stone-200">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2"><Store className="h-5 w-5 text-orange-600" />
                  <span className="font-display font-bold text-stone-900">{row.store.name}</span></div>
                {row.store.id && (
                  <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => del(row.store.id)}>
                    <Trash2 className="h-4 w-4 text-rose-600" />
                  </Button>
                )}
              </div>
              <div className="text-xs text-stone-500 uppercase font-semibold">Faturamento hoje</div>
              <div className="font-mono-num text-2xl font-extrabold text-orange-600">{brl(row.revenue_today)}</div>
              <div className="mt-2 flex items-center gap-1 text-xs text-stone-500">
                <ShoppingBag className="h-3.5 w-3.5" /> {row.orders_today} pedidos hoje
              </div>
            </CardContent>
          </Card>
        ))}
        {list.length === 0 && (
          <Card className="col-span-full"><CardContent className="p-8 text-center text-stone-500">
            <Store className="h-8 w-8 mx-auto mb-2" />Cadastre sua primeira unidade para acompanhar múltiplas lojas.
          </CardContent></Card>
        )}
      </div>
    </div>
  );
}
